export default {
  en: {
    paragraph: '"It has drastically reduced our admin time as a club, which allows us to focus on other key\n'
      + 'areas of our business - leading to positive business growth."',
    client: 'Craig, Simon Says Dance',
  },
};
